import { render } from "./ProductDiscount.vue?vue&type=template&id=4bdc828a&scoped=true"
import script from "./ProductDiscount.vue?vue&type=script&lang=js"
export * from "./ProductDiscount.vue?vue&type=script&lang=js"

import "./ProductDiscount.vue?vue&type=style&index=0&id=4bdc828a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bdc828a"]])

export default __exports__